import { ChainId, Currency } from '@uniswap/sdk'
import { darken } from 'polished'
import React, { useEffect, useState, useMemo } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import { Text } from 'rebass'
import styled from 'styled-components'

import Card from '../Card'
import { AutoColumn } from '../Column'
import CurrencyLogo from '../CurrencyLogo'
import DoubleCurrencyLogo from '../DoubleLogo'
import { RowBetween, RowFixed } from '../Row'
import { Dots } from '../swap/styleds'
import { useDepositedMUDBalance, useDepositedUSDTBalance } from '../../state/wallet/hooks'
import { useActiveWeb3React } from '../../hooks'

export const FixedHeightRow = styled(RowBetween)`
  height: 24px;
`

export const HoverCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg2};
  :hover {
    border: 1px solid ${({ theme }) => darken(0.06, theme.bg2)};
  }
`

export default function AllFullPositionCard() {
  const { chainId } = useActiveWeb3React()

  // 根据当前网络动态设置代币信息
  const currency0 = useMemo(() => {
    if (chainId === ChainId.DEV_MUD) {
      return {
        chainId: 168167 as ChainId,
        decimals: 18,
        name: 'Wrapped MUD',
        symbol: 'WMUD'
      } as Currency
    } else {
      return {
        chainId: 168169 as ChainId,
        decimals: 18,
        name: 'Wrapped MUD',
        symbol: 'WMUD'
      } as Currency
    }
  }, [chainId])

  const currency1 = useMemo(() => {
    if (chainId === ChainId.DEV_MUD) {
      return {
        chainId: 168167 as ChainId,
        decimals: 6,
        name: 'Bridge USD',
        symbol: 'USDT'
      } as Currency
    } else {
      return {
        chainId: 168169 as ChainId,
        decimals: 6,
        name: 'Bridge USD',
        symbol: 'USDT'
      } as Currency
    }
  }, [chainId])

  const [showMore, setShowMore] = useState(true)

  const { isLoading, formattedAmount, refresh: refreshMUD } = useDepositedMUDBalance()
  const {
    isLoading: usdtLoading,
    formattedAmount: usdtFormattedAmount,
    refresh: refreshUSDT
  } = useDepositedUSDTBalance()

  useEffect(() => {
    const interval = setInterval(() => {
      refreshMUD()
      refreshUSDT()
    }, 10000)

    return () => clearInterval(interval)
  }, [refreshMUD, refreshUSDT])

  return (
    <HoverCard>
      <AutoColumn gap="12px">
        <FixedHeightRow onClick={() => setShowMore(!showMore)} style={{ cursor: 'pointer' }}>
          <RowFixed>
            <DoubleCurrencyLogo currency0={currency0} currency1={currency1} margin={true} size={20} />
            <Text fontWeight={500} fontSize={20}>
              {!currency0 || !currency1 ? <Dots>Loading</Dots> : `MUD/USDT`}
            </Text>
          </RowFixed>
          <RowFixed>
            {showMore ? (
              <ChevronUp size="20" style={{ marginLeft: '10px' }} />
            ) : (
              <ChevronDown size="20" style={{ marginLeft: '10px' }} />
            )}
          </RowFixed>
        </FixedHeightRow>
        {showMore && (
          <AutoColumn gap="8px">
            <FixedHeightRow>
              <RowFixed>
                <Text fontSize={16} fontWeight={500}>
                  MUD:
                </Text>
              </RowFixed>
              {!isLoading ? (
                <RowFixed>
                  <Text fontSize={16} fontWeight={500} marginLeft={'6px'}>
                    {formattedAmount}
                  </Text>
                  <CurrencyLogo size="20px" style={{ marginLeft: '8px' }} currency={currency0} />
                </RowFixed>
              ) : (
                '-'
              )}
            </FixedHeightRow>

            <FixedHeightRow>
              <RowFixed>
                <Text fontSize={16} fontWeight={500}>
                  USDT:
                </Text>
              </RowFixed>
              {!usdtLoading ? (
                <RowFixed>
                  <Text fontSize={16} fontWeight={500} marginLeft={'6px'}>
                    {usdtFormattedAmount}
                  </Text>
                  <CurrencyLogo size="20px" style={{ marginLeft: '8px' }} currency={currency1} />
                </RowFixed>
              ) : (
                '-'
              )}
            </FixedHeightRow>
          </AutoColumn>
        )}
      </AutoColumn>
    </HoverCard>
  )
}
